import { render, staticRenderFns } from "./Paragraph.vue?vue&type=template&id=79c91702&scoped=true&"
import script from "./Paragraph.vue?vue&type=script&lang=ts&"
export * from "./Paragraph.vue?vue&type=script&lang=ts&"
import style0 from "./Paragraph.vue?vue&type=style&index=0&id=79c91702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c91702",
  null
  
)

export default component.exports